import axiosInstance from '../http/axiosSetup';

const tokenFunction = () => {
    const token = sessionStorage.getItem('token');
    return `${token}`;
};

export type smsAuthType = {
    smsId: number;
    smsCode: string;
};
export default class ContractService {
    static getProjectProperties = (queryParams) => {
        return axiosInstance
            .get('project/properties', {
                params: queryParams,
            })
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err.response;
            });
    };
    static getAttributes = () => {
        return axiosInstance
            .get('common-data-managements/attributes')
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err.response;
            });
    };
    static saveNewContract = (body) => {
        return axiosInstance
            .post('/contracts', body)
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err.response;
            });
    };
    static verifySmsCode = (body: smsAuthType) => {
        return axiosInstance
            .post('/sms-auth', body)
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err.response;
            });
    };
    static sendSmsCode = (body: Record<'phoneNumber', string>, partnerId: string, contractNumber: number) => {
        return axiosInstance
            .post(`contracts/${partnerId}/${contractNumber}/sms-sign`, body)
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err.response;
            });
    };
    static emailCheck = (body: Record<string, any>) => {
        return axiosInstance
            .post(`validations/email-address-validation`, body)
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return err.response;
            });
    };
}
